import { defineStore } from "pinia";
import { sections_actions, sections_getters, sections_state } from "./sections";

export const useSectionsStore = defineStore("section", {
  state: () => sections_state,
  actions: sections_actions,
  getters: sections_getters
});
